<template>
    <div class="news">
        <img class="news-bg-1" src="@/assets/index/milestone/bg1.png" alt="">

        <div class="news-title show-page">
            <div class="t1 bold bounceUpIn">News</div>
            <div class="arrow-box slideInLeft">
                <img @click="scrollSlide(-1, 1)" src="@/assets/index/games/arrow.png" alt="">
                <img @click="scrollSlide(1, 1)" class="right" src="@/assets/index/games/arrow.png" alt="">
            </div>
        </div>
        <div class="news-box show-page">
            <img class="mile-line zoomIn" src="@/assets/index/milestone/milestone2.png" alt="">
            <div ref="scroll1" class="home-news-scroll">
                <div v-for="(item,idx) in files" :key="idx" class="home-news zoomIn" :style="`animation-delay:${getDt(idx)}s`">
                    <div class="top">
                        <img src="@/assets/index/news/newsicon.png" alt="">
                        <div class="h3 ts">{{getTs(item.ts)}}</div>
                    </div>
                    <div class="title bold">{{item.title}}</div>
                    <div class="h3 content">{{item.content}}</div>
                    <div @click="toLink(item.link)" class="info">Read More ></div>
                </div>
            </div>
        </div>

        <img class="news-decorate" src="@/assets/index/momoverse/decorate1.png" alt="">
    </div>
</template>

<script>
import Common from '@/utils/Common';

export default {
    data(){
        return {
            news:0,
            newsdt:0.1,
            files:[
                {title:"YGG Partnership!", link:"https://mbox.medium.com/mobox-partners-with-yield-guild-games-6e05fd4b567?source=user_profile---------1----------------------------", content:"Team MOBOX is very excited to welcome Yield Guild Games as one of our strategic partners. Joining together will allow us both to reach successes for both communities alike. This will also enable our future users the opportunity to participate in a whole new economy. This will also enable us to expand and market our MOMOverse to a wider crypto audience!", ts:"1635219637"},
                {title:"MOBOX-Binance Research", link:"https://research.binance.com/en/projects/mobox", content:"MOBOX is a gaming platform that combines yield farming and farming NFTs to create a free-to-play and play-to-earn ecosystem. MOBOX believes that each metaverse can be connected through NFTs, and aims to achieve NFT interoperability across games and platforms.", ts:"1629346594"},
                {title:"A Guide to Mobox", link:"https://faqen.mobox.io/", content:"MOBOX is a gaming platform that combines yield farming and farming NFTs to create a free-to-play and play-to-earn ecosystem. MOBOX believes that each metaverse can be connected through NFTs, and aims to achieve NFT interoperability across games and platforms.", ts:"1635306037"},
                {title:"Community Update #31", link:"https://www.mobox.io/community/article/618a2c6740256ce1d7b41b80", content:"Hey Hey MOBOXers!Here we are with another update for y'all!Stay up to date, read along and check out what we have been up to and what's in the works.🔍 Have a browse below 👇", ts:"1636698079"},
                {title:"MOBOX Token- Nasdaq", link:"https://www.nasdaq.com/articles/this-crypto-is-up-414-in-the-past-month.-should-you-buy-2021-09-01", content:"MOBOX (MBOX) is a cryptocurrency token that launched in April 2021, but it has recently become much more popular. On Aug. 19, 2021, Binance announced that MOBOX would be the 22nd project on Binance Launchpool, which lets investors stake tokens to earn new types of cryptocurrencies.", ts:"1632377882"},
            ]
        }
    },

    mounted() {
        this.files.sort((a,b)=>{
            return b.ts - a.ts
        })
    },

    methods:{
        getTs(ts){
            return Common.dateFtt("yyyy-MM-dd", new Date(ts*1000));
        },
        toLink(link){
            window.open(link)
        },
        getDt(idx){
            return this.news + this.newsdt*idx
        },
        scrollSlide(direction) {
            const $scroll =  window.$(this.$refs.scroll1);
            const wholeWidth = $scroll.scrollWidth;
            const scrollOffset = $scroll.scrollLeft();

            const scrollTo =
                direction < 0
                ? scrollOffset - 200 < 0
                    ? 0
                    : scrollOffset - 200
                : scrollOffset + 200 > wholeWidth
                ? wholeWidth
                : scrollOffset + 200;

            $scroll.animate(
                {
                scrollLeft: `${scrollTo}px`,
                },
                200
            );
        },
    }
}
</script>

<style lang="less" scoped>
    .news{
        padding: 187px 0;
        position: relative;

        .news-bg-1{
            position: absolute;
            width: 100%;
            bottom: 0;
        }

        .news-title{
            text-align : center;
            position: relative;
            margin-bottom: 30px;

            .arrow-box{
                position: absolute;
                right: 10%;
                top: 50%;
                transform: translate(0, -50%);

                img{
                    width: 44px;
                    cursor: pointer;
                    margin: 0 5px;
                }

                .right{
                    transform: rotate(180deg);
                }
            }
        }

        .news-box{
            width: 85%;
            margin: auto;

            .mile-line{
                width: 100%;
                margin-bottom: 50px;
            }
        }

        .home-news-scroll {
            white-space: nowrap;
            overflow: auto;
            max-width: 100%;
            position: relative;

            padding: 0 0 45px 0;
        }

        .home-news {
            /* max-width: 350px;
            display: inline-block; */
            width: 33%;
            max-width: 335px;
            display: inline-block;
            margin: 0 2% 0 0;
            transition: 0.2s all;
            position: relative;
            
            .top{
                display: flex;
                align-items: center;
                justify-content: space-between;

                .h3{
                    color : #A2A2A2;
                }
            }

            .title{
                white-space: nowrap;
                text-overflow:ellipsis;
                overflow: hidden;
                width: 100%;
                font-size: 18px;
                padding: 20px 0;
                // padding: 10px 0;
                // height: 60px;
                // line-height: 20px;

                // white-space: break-spaces;
                // display: -webkit-box;
                // -webkit-line-clamp: 2; /*文本显示3行*/
                // overflow: hidden; /*文本超出隐藏*/
                // -webkit-box-orient: vertical;/*伸缩盒子的子元素垂直排列*/
            }

            .content{
                white-space: break-spaces;
                width: 100%;
                height: 110px;
                // overflow: auto;
                display: -webkit-box;
                -webkit-line-clamp: 5; /*文本显示3行*/
                overflow: hidden; /*文本超出隐藏*/
                -webkit-box-orient: vertical;/*伸缩盒子的子元素垂直排列*/
            }

            .info{
                display: inline-block;
                cursor: pointer;
                color: #1949C6;
                margin-top: 25px;
                font-weight: bold;
            }
        }

        .news-decorate{
            width: 312px;
            position: absolute;
            bottom: -110px;
            left: 0;
            transform: scaleX(-1);
        }
    }
</style>
